/**
 * Theme scripts.
 */
(function () {
  "use strict";

  // Mobile nav toggle (hamburger)
  const hamburger = document.getElementById("hamburger");
  const nav = document.getElementById("mainNav");

  if (hamburger && nav) {
    function setNavOpen(open) {
      hamburger.classList.toggle("open", open);
      nav.classList.toggle("mobile-open", open);
      document.body.classList.toggle("no-scroll", open);
    }

    hamburger.addEventListener("click", function () {
      setNavOpen(!nav.classList.contains("mobile-open"));
    });

    // Close the menu when a nav link is tapped (mobile UX). The browser still
    // performs the anchor navigation after the handler runs.
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        setNavOpen(false);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.classList.contains("mobile-open")) {
        setNavOpen(false);
      }
    });
  }

  // Smooth scroll para âncoras internas. Mobile: roda em conjunto com o
  // handler do menu acima, que já fecha o nav antes do scroll começar.
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      const href = link.getAttribute("href");
      if (!href || href === "#") return;
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({
        behavior: reduceMotion ? "auto" : "smooth",
        block: "start",
      });
      history.replaceState(null, "", href);
    });
  });

  // Gallery lightbox (images + video)
  const lightbox = document.getElementById("lightbox");
  const stage = document.getElementById("lightboxStage");
  const closeBtn = document.getElementById("lightboxClose");
  const items = document.querySelectorAll(".gallery-item");
  let lastFocused = null;

  function openLightbox(item) {
    if (!lightbox || !stage) return;
    lastFocused = item;
    stage.innerHTML = "";

    if (item.getAttribute("data-type") === "video") {
      const video = document.createElement("video");
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      [
        ["data-mp4", "video/mp4"],
        ["data-mov", "video/quicktime"],
      ].forEach(function (pair) {
        const url = item.getAttribute(pair[0]);
        if (url) {
          const source = document.createElement("source");
          source.src = url;
          source.type = pair[1];
          video.appendChild(source);
        }
      });
      stage.appendChild(video);
    } else {
      const img = document.createElement("img");
      img.src = item.getAttribute("data-full");
      const thumb = item.querySelector("img");
      img.alt = thumb ? thumb.alt : "";
      stage.appendChild(img);
    }

    lightbox.classList.add("open");
    lightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("no-scroll");
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    if (!lightbox || !stage) return;
    const video = stage.querySelector("video");
    if (video) video.pause();
    lightbox.classList.remove("open");
    lightbox.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
    stage.innerHTML = "";
    if (lastFocused) lastFocused.focus();
  }

  items.forEach(function (item) {
    item.addEventListener("click", function () {
      openLightbox(item);
    });
    item.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        openLightbox(item);
      }
    });
  });

  if (closeBtn) closeBtn.addEventListener("click", closeLightbox);

  // Close on backdrop click (but not when clicking the media itself)
  if (lightbox) {
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && lightbox && lightbox.classList.contains("open")) {
      closeLightbox();
    }
  });

})();
